"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _CordovaFileHelper = _interopRequireWildcard(require("./CordovaFileHelper"));

var _FileReaderWriterWrapper = _interopRequireDefault(require("../cordovaPluginWrappers/FileReaderWriterWrapper"));

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var _EmsDownloaderForBrowser = require("./EmsDownloaderForBrowser");

var _DrupalToEMSHelper = _interopRequireDefault(require("../common/components/Equizzer/services/DrupalToEMSHelper"));

var _MuiAlertHelper = require("./MuiAlertHelper");

var _strings = require("../../config/strings");

// eslint-disable-line
var CourseLoader = /*#__PURE__*/function () {
  function CourseLoader() {
    (0, _classCallCheck2["default"])(this, CourseLoader);
    this.homeCourse = null;
    this.courses = {};
  }

  (0, _createClass2["default"])(CourseLoader, [{
    key: "clearCache",
    value: function clearCache() {
      this.homeCourse = null;
      this.courses = {};
    }
  }, {
    key: "getCourse",
    value: function () {
      var _getCourse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(emsId) {
        var cachedValue;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (emsId) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Cannot look for course with emsId === undefined or null!');

              case 2:
                // check if loaded
                cachedValue = this.courses[emsId];

                if (!cachedValue) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", _promise["default"].resolve(cachedValue));

              case 5:
                _context.next = 7;
                return this.loadHomeCourse();

              case 7:
                // check if loaded now
                cachedValue = this.courses[emsId];

                if (!cachedValue) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", _promise["default"].resolve(cachedValue));

              case 10:
                throw new Error("Course with id ".concat(emsId, " not found, even after local reload"));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCourse(_x) {
        return _getCourse.apply(this, arguments);
      }

      return getCourse;
    }()
  }, {
    key: "getHomeCourse",
    value: function getHomeCourse() {
      // console.log('homeCourse courseLoader', this.homeCourse)
      if (!this.homeCourse) {
        var error = 'home course requested but not yet loaded';
        console.error(error);
        throw new Error(error);
      }

      return this.homeCourse;
    }
  }, {
    key: "getChapters",
    value: function getChapters() {
      var homeCourse = this.getHomeCourse(); // console.log('homeCourse getChapters', homeCourse)

      if (homeCourse && homeCourse.chapters) {
        return homeCourse.chapters;
      } else {
        return null;
      }
    }
    /**
     * Must be called after the home course is available
     * @param type
     * @param chapters
     * @returns {*}
     */

  }, {
    key: "getChapterByType",
    value: function getChapterByType(type) {
      var _this = this;

      var chapters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getChapters();

      // console.log('looking for chapter with type', type, chapters)
      if (!chapters) {
        return null;
      }

      var foundChapter = null;
      chapters.some(function (chapter) {
        if (chapter.type === type) {
          foundChapter = chapter;
          return true;
        }

        if (chapter.chapters) {
          var foundInnerChapter = _this.getChapterByType(type, chapter.chapters);

          if (foundInnerChapter) {
            foundChapter = foundInnerChapter;
            return true;
          }
        }

        return false;
      });
      return foundChapter;
    }
  }, {
    key: "loadHomeCourse",
    value: function () {
      var _loadHomeCourse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var currentHomeCourseId;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.HOMECOURSE_ID);

              case 2:
                currentHomeCourseId = _context2.sent;
                return _context2.abrupt("return", this.parse(currentHomeCourseId));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadHomeCourse() {
        return _loadHomeCourse.apply(this, arguments);
      }

      return loadHomeCourse;
    }()
    /**
     * This method must only be called by <App />!!!
     * @param newHomeCourse
     */

  }, {
    key: "setHomeCourse",
    value: function setHomeCourse(newHomeCourse) {
      // console.log('setting home course', newHomeCourse)
      this.homeCourse = newHomeCourse;
    }
  }, {
    key: "parse",
    value: function () {
      var _parse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(emsId) {
        var inheritedCourseTypes,
            xml,
            course,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                inheritedCourseTypes = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : [];

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context3.next = 5;
                  break;
                }

                xml = (0, _EmsDownloaderForBrowser.getFileForBrowserFromCache)(emsId);
                _context3.next = 28;
                break;

              case 5:
                if (!_config["default"].useDrupalContent) {
                  _context3.next = 18;
                  break;
                }

                _context3.t0 = _FileReaderWriterWrapper["default"];
                _context3.next = 9;
                return _CordovaFileHelper["default"].getFileEntry("".concat(emsId, ".json"), _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

              case 9:
                _context3.t1 = _context3.sent;
                _context3.next = 12;
                return _context3.t0.readFileAsText.call(_context3.t0, _context3.t1);

              case 12:
                xml = _context3.sent;
                _context3.next = 15;
                return _DrupalToEMSHelper["default"].translateDrupalContentToEMSContentWithId(emsId);

              case 15:
                course = _context3.sent;
                _context3.next = 28;
                break;

              case 18:
                _context3.t2 = _FileReaderWriterWrapper["default"];
                _context3.next = 21;
                return _CordovaFileHelper["default"].getFileEntry(emsId, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

              case 21:
                _context3.t3 = _context3.sent;
                _context3.next = 24;
                return _context3.t2.readFileAsText.call(_context3.t2, _context3.t3);

              case 24:
                xml = _context3.sent;
                _context3.next = 27;
                return this.parseXmlStringToCourse(xml, inheritedCourseTypes);

              case 27:
                course = _context3.sent;

              case 28:
                // console.log('CourseLoader parse', xml, course, emsId)
                // const xml = await CordovaFileHelper.gettgetXml(emsId)
                // const xml = PLAIN_XML[emsId]
                this.courses[emsId] = course;
                return _context3.abrupt("return", _promise["default"].resolve(course));

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function parse(_x2) {
        return _parse.apply(this, arguments);
      }

      return parse;
    }()
  }, {
    key: "getChildren",
    value: function getChildren(xmlNode) {
      // all browser vs Internet Explorer
      if (xmlNode.children) {
        return xmlNode.children;
      } // if it has a tag name it is a real node, otherwise it's probably just a line break


      var children = [];

      for (var i = 0; i < xmlNode.childNodes.length; i++) {
        var node = xmlNode.childNodes[i];

        if (!node || node.tagName) {
          children.push(node);
        }
      }

      return children;
    }
  }, {
    key: "addDrupalContentToLocalVars",
    value: function addDrupalContentToLocalVars(id, course) {
      // console.log('addDrupalContentToLocalVars', id, course)
      this.courses[id] = course;
    }
  }, {
    key: "parseXmlStringToCourse",
    value: function () {
      var _parseXmlStringToCourse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(xml) {
        var inheritedCourseTypes,
            parser,
            xmlDoc,
            children,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                inheritedCourseTypes = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : [];
                parser = new window.DOMParser();
                xmlDoc = parser.parseFromString(xml, 'text/xml');
                window.xmlDoc = xmlDoc;
                children = this.getChildren(xmlDoc);
                return _context4.abrupt("return", this.xmlNodeToCourse(children[0], inheritedCourseTypes));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function parseXmlStringToCourse(_x3) {
        return _parseXmlStringToCourse.apply(this, arguments);
      }

      return parseXmlStringToCourse;
    }()
  }, {
    key: "xmlNodeToCourse",
    value: function () {
      var _xmlNodeToCourse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(courseNode) {
        var inheritedTypes,
            course,
            isCourseTypeInheriting,
            inheritingTypes,
            coursePromises,
            children,
            i,
            child,
            tagName,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                inheritedTypes = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : [];
                course = {
                  pages: []
                };
                (0, _keys["default"])(courseNode.attributes).forEach(function (key) {
                  var attribute = courseNode.attributes[key];

                  if (!attribute.name || attribute.value === null) {
                    console.error('something expected is not defined: `attribute` does not have name and/or value', key, attribute);
                    return;
                  }

                  course[attribute.name] = attribute.value;
                });
                course.inheritedTypes = inheritedTypes;
                isCourseTypeInheriting = _config["default"].inheritingCourseTypes.includes(course.type);
                inheritingTypes = isCourseTypeInheriting ? inheritedTypes.concat(course.type) : inheritedTypes;
                coursePromises = [];
                children = this.getChildren(courseNode);
                i = 0;

              case 9:
                if (!(i < children.length)) {
                  _context5.next = 18;
                  break;
                }

                child = children[i];

                if (child.tagName) {
                  _context5.next = 13;
                  break;
                }

                throw new Error('something expected is not defined: tagName missing');

              case 13:
                tagName = child.tagName;

                if (tagName === 'ref') {
                  coursePromises.push(this.parse(child.getAttribute('id'), inheritingTypes));
                } else if (tagName === 'page') {
                  course.pages.push(this.xmlNodeToPage(child));
                }

              case 15:
                i++;
                _context5.next = 9;
                break;

              case 18:
                _context5.next = 20;
                return _promise["default"].all(coursePromises);

              case 20:
                course.chapters = _context5.sent;
                return _context5.abrupt("return", _promise["default"].resolve(course));

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function xmlNodeToCourse(_x4) {
        return _xmlNodeToCourse.apply(this, arguments);
      }

      return xmlNodeToCourse;
    }()
  }, {
    key: "xmlNodeToPage",
    value: function xmlNodeToPage(pageNode) {
      var _this2 = this;

      var page = {
        elements: []
      };
      (0, _keys["default"])(pageNode.attributes).forEach(function (key) {
        var attribute = pageNode.attributes[key];

        if (!attribute.name || attribute.value === null) {
          console.error('something expected is not defined: `attribute` does not have name and/or value', key, attribute);
          return;
        }

        page[attribute.name] = attribute.value;
      });
      var children = this.getChildren(pageNode);
      (0, _values["default"])(children).forEach(function (child) {
        if (!child) {
          throw new Error('something expected is not defined: no child');
        }

        var element = _this2.xmlNodeToElement(child);

        if (element) {
          page.elements.push(element);
        }
      });
      return page;
    }
  }, {
    key: "xmlNodeToElement",
    value: function xmlNodeToElement(elementNode) {
      var element = {
        type: elementNode.tagName
      };
      (0, _keys["default"])(elementNode.attributes).forEach(function (key) {
        var attribute = elementNode.attributes[key];

        if (!attribute.name || attribute.value === null) {
          console.error('something expected is not defined: `attribute` does not have name and/or value', key, attribute);
          return;
        }

        element[attribute.name] = attribute.value;
      });

      if (elementNode.tagName === 'element') {
        var children = this.getChildren(elementNode);
        (0, _keys["default"])(children).forEach(function (key) {
          var child = children[key];

          if (!child.innerHTML) {
            if (!child.textContent) {
              throw new Error('something expected is not defined: both innerHTML and textContent are missing');
            }

            child.innerHTML = child.textContent;
          }

          if (child.tagName === 'content') {
            element.content = child.innerHTML;
          }
        });
      }

      return element;
    }
  }]);
  return CourseLoader;
}();

var instance = new CourseLoader();
var _default = instance;
exports["default"] = _default;